import { action } from 'typesafe-actions';
// eslint-disable-next-line no-unused-vars
import { ScheduleInterface, ScheduleTypes } from './types';

// List Schedule
export const listScheduleRequest = (payload: object) =>
  action(ScheduleTypes.LIST_SCHEDULE_REQUEST, payload);
export const listScheduleSuccess = (payload: {
  scheduleList: ScheduleInterface[];
}) => action(ScheduleTypes.LIST_SCHEDULE_SUCCESS, payload);
export const listScheduleFailure = () =>
  action(ScheduleTypes.LIST_SCHEDULE_FAILURE);

// Create Schedule
export const createScheduleByListRequest = (
  payload: Array<{
    date: number;
    month: number;
    year: number;
    type: number;
    name: string;
  }>,
) => action(ScheduleTypes.CREATE_SCHEDULE_REQUEST, payload);
export const createScheduleByListSuccess = () =>
  action(ScheduleTypes.CREATE_SCHEDULE_SUCCESS);
export const createScheduleByListFailure = () =>
  action(ScheduleTypes.CREATE_SCHEDULE_FAILURE);

// Update Schedule
export const updateScheduleByListRequest = (
  payload: Array<{
    calendarId: string;
    date: number;
    month: number;
    year: number;
    type: number;
    name: string;
  }>,
) => action(ScheduleTypes.UPDATE_SCHEDULE_REQUEST, payload);
export const updateScheduleByListSuccess = () =>
  action(ScheduleTypes.UPDATE_SCHEDULE_SUCCESS);
export const updateScheduleByListFailure = () =>
  action(ScheduleTypes.UPDATE_SCHEDULE_FAILURE);

// Delete Schedule
export const deleteScheduleRequest = (payload: object) =>
  action(ScheduleTypes.DELETE_SCHEDULE_REQUEST, payload);
export const deleteScheduleSuccess = () =>
  action(ScheduleTypes.DELETE_SCHEDULE_SUCCESS);
export const deleteScheduleFailure = () =>
  action(ScheduleTypes.DELETE_SCHEDULE_FAILURE);
